class TriggerInfo {
  ADI = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  ALD = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  ALT = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  ATM = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  ATS = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  MAN = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VFR = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VLT = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VLV = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VMT = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VMD = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  AMH = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VMH = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  VMW = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  RFG = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  RFI = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}
  RSG = { id: 0, triggercode: '', name: '',  description: '' , title: function () {return `${this.triggercode}: ${this.name}`}}

  constructor(triggersInfo = []){
    triggersInfo.forEach(t => {
      this[t.triggercode] = {...t, title: this.title(t)}
    })
  }
  title(obj={}){
    return `${obj.triggercode}: ${obj.name}`}
}

export default TriggerInfo
